export const updateProviderDrMode = `
  mutation($drMode: Boolean!, $providerId: String!){
    updateProviderDrMode(modes: {drMode: $drMode, providerId: $providerId}) {
      providerId
      drMode
    }
  }
`;
